exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.detail-row[data-v-cf627950] {\n  white-space: normal;\n}\n.sale-requests[data-v-cf627950] {\n  /*& /deep/ .md-content:not(.md-table-content) {\n    margin-right: -8px;\n  }\n  & /deep/ .md-table-content {\n    padding-right: 8px;\n  }*/\n}\n.sale-requests .details-column[data-v-cf627950] {\n    padding: 12px 46px 0 12px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cf627950","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/requests/index/Requests.SaleCreation.vue
// module id = LhM4
// module chunks = 1